import { render, staticRenderFns } from "./matching-dialog.vue?vue&type=template&id=4a8833b8&scoped=true"
import script from "./matching-dialog.vue?vue&type=script&lang=js"
export * from "./matching-dialog.vue?vue&type=script&lang=js"
import style0 from "./matching-dialog.vue?vue&type=style&index=0&id=4a8833b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8833b8",
  null
  
)

export default component.exports